import Backbone from 'backbone'
import _ from 'lodash'
import Toolbar from './editor-toolbar'
import $ from 'jquery'
import deviceType from 'scoreboard/components/device-type'
import tinymce from 'tinymce/tinymce'
import 'tinymce/plugins/paste'

var Editor = Backbone.View.extend({
	className: 'rich-text-content',

	/**
	 * @param {Object} opt
	 *
	 * @param {Boolean} [opt.selectAllMode=false] - see editor-toolbar.js
	 *
	 * @param {String} opt.text - the initial text in the editor
	 */
	initialize: function (opt = {}) {
		this._initial = opt.text
		this.options = opt
		_.bindAll(this, '_triggerChange')
	},

	render: function () {
		if (this._initial) {
			this.$el.html(this._initial)
			delete this._initial
		}

		tinymce.init({
			target: this.el,
			inline: true,
			plugins: [ 'paste' ],
			skin: false,
			toolbar: false,
			statusbar: false,
			menubar: false,
			// See tinymce/icons/default/icons.js for why this is necessary
			base_url: document.location.protocol + '//' + document.location.host + '/resources/tinymce',
			// #23647 don't convert absolute URLs to the same host into relative URLs
			convert_urls: false,
			custom_ui_selector: '.color-picker, .color-picker-tooltip, .color-icon, .editor-toolbar',
			invalid_elements: 'table,thead,th,tbody,tr,td,blockquote',
			invalid_styles: 'font-weight color font-size font-family background background-color',
			theme: function(editor, target) {
				// Just some crap we give tinymce to fool it into thinking it's a custom "theme"
				return {
					editorContainer: $('<div>').addClass('is-not-displayed').insertAfter(target)[0],
					iframeContainer: $('<div>').addClass('is-not-displayed').insertAfter(target)[0]
				}
			},
			paste_postprocess: function(plugin, args) {
				if (args.internal) {
					// if this is an internal paste (ie copied from the editor), then the HTML should already be valid
					return
				}

				// pastes from some sources (like Pages) will include CSS classes. There's no reason we'd want them.
				$(args.node).find('[class]').removeAttr('class')
			},
			init_instance_callback : function(editor) {
				this.editor = editor

				this.editor.formatter.register('text-color', { selector: '*', inline: 'span', classes: [ 'rich-text-color-%color' ] })
				this.editor.formatter.register('text-size', { selector: '*', inline: 'span', classes: [ 'rich-text-size-%size' ] })

				_.forEach([ 'Change', 'KeyUp', 'ExecCommand', 'Paste', 'Input' ], function (event) {
					this.editor.on(event, this._triggerChange.bind(this))
				}.bind(this))

				this.editor.on('Focus', function () {
					this.trigger('focus')
				}.bind(this))

				this._previousVal = this.val()

				this.trigger('load')
			}.bind(this)
		})

		return this
	},

	focus: function () {
		this.editor.focus(false)
	},

	setCursor: function (container, offset) {
		this.editor.selection.setCursorLocation(container, offset)
	},

	selectAll: function () {
		let all = this.editor.getBody()

		if (all.childElementCount > 0) {
			let range = document.createRange()
			range.setStart(all.firstChild, 0)
			range.setEnd(all.lastChild, all.lastChild.nodeType === Node.TEXT_NODE
				? all.lastChild.length : all.lastChild.childNodes.length)
			this.editor.selection.setRng(range)
		}
	},

	_triggerChange: function () {
		var newVal = this.val()
		// We have to use broader events than we'd like (like keyup), because IE11 doesn't trigger the 'input' event.
		// But we don't want to fire unnecessary 'change' events (like when arrow keys are pressed), so compare to
		// the previous value before triggering the 'change' event
		if (this._previousVal === newVal) {
			return
		}
		this._previousVal = newVal
		this.trigger('change', newVal)
	},

	val: function () {
		return this.editor.getContent()
	},

	createToolbar: function () {
		return new Toolbar({
			editor: this.editor,
			editorView: this,
			selectAllMode: this.options.selectAllMode
		})
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this)
		this._destroyEditor()
	},

	_destroyEditor: function () {
		if (this.editor) {
			this.editor.remove()
		}
	},

	/**
	 * Alternative to remove() that leaves the DOM node in place, but destroys the
	 * editor and event listeners
	 */
	detach: function () {
		this._destroyEditor()
		this.undelegateEvents()
	}

})

export default Editor

Editor.__filename__ = 'components/rich-text/editor.js'
